import React, { useCallback, useState, useEffect, useMemo } from 'react'
import { deleteTasks, getActivityApi, getTasks, saveTask, updateTasks } from '../../CommunityActionCreator'
import { Navigate, useLocation } from 'react-router-dom';
import Loader from '../../../../../../presentationals/Loader/Loader.component';
import AddEventPopup from './AddEventPopup';

import { Calendar, Views, momentLocalizer } from 'react-big-calendar'
// import SchedulerCustom from './Scheduler';
import "react-big-calendar/lib/css/react-big-calendar.css";
import moment from 'moment'
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop'
import 'react-big-calendar/lib/addons/dragAndDrop/styles.scss'
import DeletePopup from '../../deletePopup'



const DragAndDropCalendar = withDragAndDrop(Calendar)

const ActivityPage = ({ rowData }) => {
    const [activityData, setactivityData] = useState([])
    const location = useLocation();
    const [loaderState, setloaderState] = useState(false)

    const [myEventsList, setMyEventsList] = useState([])

    const [handleSelectStart, setHandleSelectStart] = useState('')
    const [handleSelectEnd, setHandleSelectEnd] = useState('')
    const [addEventPopupState, setAddEventPopupState] = useState(false)
    const [deletePopupState, setDeletePopupState] = useState(false)
    const forceUpdate = React.useState()[1].bind(null, {})
    const [idToDelete, setIdToDelete] = useState(0)
    const [defaultDateCal, setDefaultDateCal] = useState(new Date())


    const localizer = momentLocalizer(moment)
    let defaultDateNew =

        useEffect(() => {
            let dataToPush = []
            dataToPush.push({
                communityId: null,
                // date: location.state && location.state.rowData ? location.state.rowData.addedOn : '',
                date: rowData ? moment(rowData.applyDate).format("YYYY-MM-DD hh:mm:ss").toString() : "",
                employeeId: rowData ? rowData.emailId : '',
                id: 0,
                comment: "Lead Generated",
                lenderId: "initial",
                loanId: rowData ? rowData.loanId : '',
                status: null,
                userId: null
            })
            setloaderState(true)
            getActivityApi(rowData ? rowData.loanId : rowData.loanId, callBack => {
                if (callBack) {
                    // setactivityData(callBack)
                    callBack.map((data, i) => {
                        dataToPush.push(data)
                    })
                    setactivityData(dataToPush)
                    setloaderState(false)
                }
            }, error => {
                setloaderState(false)

            })

            var check = moment(new Date())
            var month = check.format('M');
            var year = check.format('YYYY');

            getTasksData(rowData.loanId, month, year);
        }, [])

    let navigate = {
        PREVIOUS: 'PREV',
        NEXT: 'NEXT',
        TODAY: 'TODAY',
        DATE: 'DATE',
    }

    const moveEvent = useCallback(({ event, start, end, isAllDay: droppedOnAllDaySlot = false }) => {
        const { allDay } = event
        if (!allDay && droppedOnAllDaySlot) {
            event.allDay = true
        }
        let existing = null;
        setMyEventsList((prev) => {
            existing = prev.find((ev) => ev.id === event.id) ?? {}
            const filtered = prev.filter((ev) => ev.id !== event.id)
            return [...filtered, { ...existing, start, end, allDay }]
        })
        const data = {
            start: start,
            end: end,
            title: existing.title,
            id: existing.id,
            empId: existing.adminId,
            loanId: existing.loanId
        }
        setloaderState(true)
        updateTasks(data, callBack => {
            if (callBack && callBack.data === "success") {

            }
            setloaderState(false)
        }, error => {
            setloaderState(false)
        })

    },
        [setMyEventsList]
    )

    // const resizeEvent = useCallback(
    //     ({ event, start, end }) => {
    //         setMyEventsList((prev) => {
    //             const existing = prev.find((ev) => ev.id === event.id) ?? {}
    //             const filtered = prev.filter((ev) => ev.id !== event.id)

    //             return [...filtered, { ...existing, start, end }]
    //         })
    //     },
    //     []
    // )

    const addEventHandler = ({ start, end }) => {

        setHandleSelectStart(start)
        setHandleSelectEnd(end)
        forceUpdate()
        setAddEventPopupState(true)
    }

    const handleSelectSlot = (title, type) => {

        if (type === "close") {
            setAddEventPopupState(false)
        } else {
            let data = {
                start: handleSelectStart,
                end: handleSelectEnd,
                title: title,
                id: 0,
                empId: window.sessionStorage.getItem("adminId"),
                loanId: rowData.loanId
            }

            saveTask(data, callBack => {
                setloaderState(true)
                var check = moment(handleSelectEnd, 'E MMM dd yyyy HH:mm:ss')
                var month = check.format('M');
                var year = check.format('YYYY');
                getTasksData(rowData.loanId, month, year)
            }, error => {
                setloaderState(false)
            })
            setloaderState(false)
            forceUpdate()
            setAddEventPopupState(false)
        }
    }

    const handleSelectEvent = useCallback((event) => {
        console.log(myEventsList)
    }, []
    )

    const { defaultDate, scrollToTime } = useMemo(
        () => ({
            defaultDate: new Date(),
            scrollToTime: new Date(2022, 1, 1, 6),
        }), []
    )

    const doubleEventClick = (event) => {
        if (event) {
            setIdToDelete(event.id)
            setDeletePopupState(true)
        }
    }

    const getTasksData = (loanId, month, year) => {
        setloaderState(true)
        getTasks(loanId ? loanId : rowData.loanId, month, year, callBack => {
            if (callBack && callBack.data) {
                setMyEventsList(callBack.data)
            }
            setloaderState(false)
        })
        setloaderState(false)
    }

    const deleteHandler = (e) => {
        if (e === 'yes') {
            deleteTasks(idToDelete, callback => {
                var check = moment(new Date())
                var month = check.format('M');
                var year = check.format('YYYY');
                getTasksData(rowData.loanId, month, year);
            }, error => {

            })
        } else {

        }
        setDeletePopupState(false)
    }

    const showMoreEvents = ({ events, date }) => {
        console.log(events);
    }


    const navigateIt = async action => {
        // this.props.onNavigate(action)
        // Calendar.onNavigate(Calendar.Navigate.NEXT)
        // Calendar.Navigate.NEXT
        // setDefaultDateCal(moment(defaultDateCal).subtract(7, "days").format("DD-MM-YYYY"))
        let datetoset = moment(defaultDateCal).subtract(31, "days")
        await setDefaultDateCal(datetoset._d)
        forceUpdate()



    }
    const CustomToolbar = (toolbar) => {


        const goToBack = () => {
            // console.log(toolbar.date.getMonth());

            toolbar.date.setMonth(toolbar.date.getMonth() - 1);
            // toolbar.onNavigate('PREV')
            var check = moment(toolbar.date)
            var month = check.format('M');
            var year = check.format('YYYY');

            getTasksData(null, month, year);
        }

        const goToNext = () => {
            toolbar.date.setMonth(toolbar.date.getMonth() + 1);
            // toolbar.onNavigate('NEXT');
            var check = moment(toolbar.date)
            var month = check.format('M');
            var year = check.format('YYYY');

            getTasksData(null, month, year);
        };


        return (

            <div className="rbc-toolbar">
                <span className="rbc-btn-group">
                    <button type="button" onClick={goToBack}>Prev</button>
                </span>
                <span className="rbc-toolbar-label"><b>{toolbar.label}</b></span>
                {/* <h3 className="rbc-toolbar-label">{toolbar.label}</h3> */}
                <span className="rbc-btn-group">
                    <button type="button" onClick={goToNext}>Next</button>
                </span>
            </div>
        )
    }


    return (
        <div className='container-fluid full-height'>

            {loaderState ?
                <Loader />
                : ""}

            {
                addEventPopupState ? <AddEventPopup actionHandler={handleSelectSlot}></AddEventPopup> : ""
            }
            {
                deletePopupState ? <DeletePopup deleteHandler={deleteHandler}></DeletePopup> : ""
            }

            <div className='row'>
                <div className={window.location.href.includes("/external") ? 'col-sm-12  col-xs-12' : activityData && activityData.length > 0 ? 'col-sm-4  col-xs-12' : 'col-sm-4  col-xs-12'}
                    style={{ maxHeight: '500px', overflow: "auto" }}>
                    {activityData && activityData.map((row, i) => {
                        return (
                            <div key={i}>
                                <div className='row'>
                                    <div className='col-sm-2 col-xs-12'>
                                        <div className='activity-circle text-center' style={{width:'30px',height:'30px'}}>
                                            <div style={{ marginTop: '-4px' }}> {i + 1}</div>
                                        </div>
                                        {i + 1 < activityData.length ?
                                            <div style={{ background: '#000', width: '5px', marginLeft: 'auto', marginRight: 'auto', height: '30px', marginTop: '10px' }}></div>
                                            : <div><div style={{ background: '#bcb4b4', width: '5px', marginLeft: 'auto', marginRight: 'auto', height: '30px', marginTop: '10px' }}></div>
                                                <div className='activity-circle text-center' style={{ background: '#bcb4b4',width:'30px',height:'30px',marginTop:'20px' }}>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    <div className=' col-sm-10 col-xs-12 text-left'>
                                        <h6 className='mt-3'> <b>{row.comment} </b></h6>
                                        <p className='mb-0' style={{ color: '#7681a2' }}>{row.employeeId}</p>
                                        <p className='mb-0' style={{ color: '#7681a2' }}>{row.date}</p>
                                    </div>
                                </div>

                            </div>

                        )
                    })}

                </div>

                {
                    !window.location.href.includes("/external") ?
                        <div className={activityData && activityData.length ? 'col-sm-8' : "col-sm-8"}>
                            <DragAndDropCalendar
                                localizer={localizer}
                                events={myEventsList}
                                startAccessor={(event) => { return new Date(event.start) }}
                                endAccessor={(event) => { return new Date(event.end) }}
                                style={{ height: 500 }}
                                defaultDate={defaultDateCal}
                                defaultView={Views.MONTH}
                                onSelectEvent={handleSelectEvent}
                                onSelectSlot={addEventHandler}
                                selectable
                                // onNavigate={( Views.MONTH, 'NEXT')}
                                scrollToTime={scrollToTime}
                                onShowMore={(events, date) => console.log(date)}
                                onDoubleClickEvent={doubleEventClick}
                                onEventDrop={moveEvent}
                                components={{
                                    toolbar: CustomToolbar
                                }}
                            // onNavigate={Navigate}
                            // onEventResize={resizeEvent}
                            />
                        </div>
                        : ""
                }
                <div className="col-sm-12">

                </div>



            </div>
        </div>
    )
}


export default ActivityPage;